<template>
<app-wrapper>
  <contact-form :requiredFields='requiredFields'
    name="exposeContact"
    :authentication-token="authenticationToken"
    :prop-immo-expose="[exposeId, customObjectId]"
  >
    <contact-logged-in></contact-logged-in>
    <contact-fields v-if="loggedIn" :include="['contactReason']" :exclude="['company', 'person', 'phone_email']"></contact-fields>
    <contact-fields v-else :include="['contactReason']" :exclude="['company']"></contact-fields>
  </contact-form>
</app-wrapper>
</template>

<script>
import AppWrapper from "../AppWrapper";
import ContactLoggedIn from "./ContactLoggedIn";
import ContactForm from "../../contact/ContactForm";
import ContactFields from "../../contact/ContactFields";

export default {
  name: "ExposeContactStandaloneApp",

  components: {
    AppWrapper,
    ContactForm,
    ContactFields,
    ContactLoggedIn
  },

  data() {
    return {
      name: "exposeContact"
    }
  },

  props: [
    "exposeId",
    "customObjectId"
  ],

  computed: {
    loggedIn() {
      return this.$store.state.user.loggedIn;
    },

    username() {
      return this.$store.state.user.email;
    },

    appLoaded() {
      return this.$store.state.appLoaded;
    },

    authenticationToken() {
      return this.$store.state.auth.authenticationToken;
    },

    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    }
  }
};
</script>
